import { combineReducers } from 'redux'
import keplerGlReducer, { combinedUpdaters } from '@eqworks/kepler.gl/reducers'
import * as Layers from '@eqworks/kepler.gl/layers'
import { NavReducer } from './nav'
import { CustomerReducer } from './customer'
import { WidgetReducer } from './widgets'
import { SlateReducer } from './slates'
import map from './map/map-reducer'
import * as CustomLayers from '../common-components/custom-kepler-layers'


Layers.LayerClasses = {
  point: Layers.LayerClasses.point,
  geojson: Layers.LayerClasses.geojson,
  heatmap: Layers.LayerClasses.heatmap,
  arc: Layers.LayerClasses.arc,
}

Object.values(CustomLayers).forEach((cl) => { Layers.LayerClasses[cl._typeName] = cl })

Layers.KeplerGlLayers = {
  ...CustomLayers,
  ...Layers.KeplerGlLayers,
}

const customizedKeplerGlReducer = keplerGlReducer
  .initialState({
    visState: { layerClasses: Layers.LayerClasses },
    uiState: { currentModal: null },
  })
  .plugin({
    APPEND_VIS_DATA: (state, action) => {
      const newState = combinedUpdaters.addDataToMapUpdater(state, action)
      let newData = []
      if (action.payload.reportReload) {
        newState.visState.layers = []
        state.visState.layerData.forEach((d, i) => {
          newData.push(newState.visState.layerData[i])
        })
        newState.visState.layerData = newData
      } else {
        newData = [...new Set([...state.visState.layerData, ...newState.visState.layerData])]
      }
      const mergedState = {
        ...state,
        ...newState,
        visState: {
          ...state.visState,
          ...newState.visState,
          layerClasses: { ...state.visState.layerClasses },
          layerData: newData,
          datasets: { ...state.visState.datasets, ...newState.visState.datasets },
          layers: [...new Set([...state.visState.layers, ...newState.visState.layers])],
          filters: [...new Set([...state.visState.filters, ...newState.visState.filters])],
          interactionConfig: {
            tooltip: { enabled: false, config: { fieldsToShow: {} } },
            brush: { enabled: false, config: { size: 1 } },
            coordinate: { enabled: false, config: {} },
          },
        },
      }
      mergedState.visState.layerOrder = mergedState.visState.layers.map((l, i) => i)
      return mergedState
    },
    UPDATE_VIS_DATA: (state, action) => {
      const newState = combinedUpdaters.addDataToMapUpdater(state, action)
      const mergedState = {
        ...state,
        ...newState,
        visState: {
          ...state.visState,
          ...newState.visState,
          layerClasses: { ...state.visState.layerClasses },
          layerData: [...state.visState.layerData],
          datasets: {
            ...state.visState.datasets,
            [action.payload.datasets.info.id]: {
              ...state.visState.datasets[action.payload.datasets.info.id],
              data: newState.visState.datasets[action.payload.datasets.info.id].data,
              allData: newState.visState.datasets[action.payload.datasets.info.id].allData,
            },
          },
          layers: [...state.visState.layers],
          interactionConfig: {
            tooltip: { enabled: false, config: { fieldsToShow: {} } },
            brush: { enabled: false, config: { size: 1 } },
            coordinate: { enabled: false, config: {} },
          },
        },
      }
      mergedState.visState.layerOrder = mergedState.visState.layers.map((l, i) => i)
      return mergedState
    },
  })

export default combineReducers({
  keplerGl: customizedKeplerGlReducer,
  nav: NavReducer.Reducer,
  customer: CustomerReducer.Reducer,
  widgets: WidgetReducer.Reducer,
  slates: SlateReducer.Reducer,
  map,
})
